export const REGEX = {
  AddComma: /(\d)(?=(\d{3})+(?!\d))/g,
  Digits: /\D/g,
};
